import React, { ReactNode, useState } from 'react';
import { InfoIcon } from './DashboardIcons';
import { useSpring, animated as a } from 'react-spring';

// Exportar a interface para que possa ser usada em outros componentes
export interface ChartContainerProps {
  title: ReactNode;
  children: ReactNode;
  fullWidth?: boolean;
  tooltip?: string;
  height?: number;
  headerContent?: ReactNode; // Propriedade para conteúdo adicional no cabeçalho
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'purple';
}

const ChartContainer: React.FC<ChartContainerProps> = ({
  title,
  children,
  fullWidth = false,
  tooltip,
  height = 500,
  headerContent,
  variant = 'default'
}) => {
  const [hovered, setHovered] = useState(false);
  
  // Animação de entrada
  const entryAnimation = useSpring({
    from: { opacity: 0, transform: 'translateY(30px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
    delay: 100,
    config: { tension: 180, friction: 22 }
  });
  
  // Animação de hover
  const hoverAnimation = useSpring({
    transform: hovered ? 'translateY(-5px)' : 'translateY(0px)',
    boxShadow: hovered 
      ? '0 12px 28px -5px rgba(0, 0, 0, 0.3), 0 8px 16px -8px rgba(0, 0, 0, 0.3)'
      : '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    config: { tension: 300, friction: 20 }
  });
  
  return (
    <a.div 
      className={`chart-container ${fullWidth ? 'full-width' : ''} ${variant}`}
      style={{...entryAnimation, ...hoverAnimation}}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="chart-header">
        <div className="chart-title-wrapper">
          {typeof title === 'string' ? 
            <h2 className="chart-title">{title}</h2> : 
            <div className="chart-title">{title}</div>
          }
          {headerContent && <div className="chart-header-content">{headerContent}</div>}
        </div>
        {tooltip && (
          <div className="tooltip-container">
            <InfoIcon className="info-icon" />
            <div className="tooltip-content">
              {tooltip}
            </div>
          </div>
        )}
      </div>
      <div className="chart-wrapper" style={{ height: `${height}px` }}>
        <div className="chart-content-wrapper">
          {children}
        </div>
      </div>
      <div className={`chart-gradient ${variant}`}></div>
    </a.div>
  );
};

export default ChartContainer; 